function normalizeQrImageSrc(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  if (/^data:image\//i.test(s)) return s;
  if (/^https?:\/\//i.test(s)) return s;
  if (/^image\/[a-z0-9+.-]+;base64,/i.test(s)) return `data:${s}`;
  const compact = s.replace(/\s/g, "");
  if (compact.length < 32) return null;
  const mime = compact.startsWith("/9j/")
    ? "image/jpeg"
    : compact.startsWith("UklGR")
      ? "image/webp"
      : "image/png";
  return `data:${mime};base64,${compact}`;
}

function asTrimmedString(value) {
  if (typeof value !== "string") return null;
  const t = value.trim();
  return t.length ? t : null;
}

function pickFromObject(obj, depth = 0) {
  if (!obj || typeof obj !== "object" || depth > 4) return null;
  const keys = [
    "qrcode",
    "qr_code",
    "qrCode",
    "qr",
    "base64",
    "imagem",
    "image",
    "qrcode_base64",
    "qrcodeBase64",
    "code",
  ];
  for (const k of keys) {
    const v = obj[k];
    const s = asTrimmedString(v);
    if (s) return s;
    if (v && typeof v === "object") {
      const nested = pickFromObject(v, depth + 1);
      if (nested) return nested;
    }
  }
  return null;
}

export function pickWhatsappQrImageSrc(body) {
  if (body == null) return null;
  if (typeof body === "string") return normalizeQrImageSrc(body);
  if (typeof body !== "object") return null;
  const direct = pickFromObject(body);
  if (direct) return normalizeQrImageSrc(direct);
  if (body.data) {
    if (typeof body.data === "string") return normalizeQrImageSrc(body.data);
    const inner = pickFromObject(body.data);
    if (inner) return normalizeQrImageSrc(inner);
    if (body.data?.data) {
      if (typeof body.data.data === "string") return normalizeQrImageSrc(body.data.data);
      const deep = pickFromObject(body.data.data);
      if (deep) return normalizeQrImageSrc(deep);
    }
  }
  return null;
}
